import AgendamentosDoAtendimento from "../AgendamentosDoAtendimento";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import {
    ListarMotivoParalisarController,
    ParalisarAtendimentoController,
    ReiniciarAtendimentoController,
} from "../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import UnForm from "../../../../Components/Form";
import { faHandPaper, faUndo } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { GetAtendimentoAssistenciaTecnicaController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/AtendimentoControllers";
import { useHistoricoContext } from "../../../../Context/Historico";

interface IParalisarVisita {
    dtSla: string;
    setDtSla: Dispatch<SetStateAction<string>>;
}

export default function ParalisarVisita(props: IParalisarVisita) {
    const AtendimentoPage = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;

    const [selectedIDMotivoParalisacao, setSelectedIDMotivoParalisacao] =
        useState<number | undefined>(undefined);

    const { execute: getAtendimento } = useAsyncCallback(
        GetAtendimentoAssistenciaTecnicaController
    );

    const {
        execute: ParalisarAtendimento,
        loading: paralisarAtendimentoLoading,
    } = useAsyncCallback(() =>
        ParalisarAtendimentoController({
            ID_CASO: Atendimento.ID_CASO,
            ID_MOTIVO_PARALIZACAO_SLA: selectedIDMotivoParalisacao ?? 0,
        })
    );

    const {
        execute: ReiniciarAtendimento,
        loading: reiniciarAtendimentoLoading,
    } = useAsyncCallback(() =>
        ReiniciarAtendimentoController(Atendimento.ID_CASO)
    );

    return (
        <div className="card">
            <UnForm handleSubmit={() => {}}>
                <div className="d-flex align-items-center p-2">
                    <UnForm.LazySelect
                        name="ID_CASO"
                        controller={ListarMotivoParalisarController}
                        getDS={(ds) => ds.DS_MOTIVO_PARALIZACAO_SLA}
                        getKeyValue={(key) => key.ID_MOTIVO_PARALIZACAO_SLA}
                        className="mt-2 form-control"
                        onChange={(event) =>
                            setSelectedIDMotivoParalisacao(
                                Number(event.target.value)
                            )
                        }
                    >
                        <option></option>
                    </UnForm.LazySelect>
                    <div className="ml-1 mt-1">
                        <UnForm.SubmitButton
                            color="danger"
                            icon={faHandPaper}
                            loading={paralisarAtendimentoLoading}
                            loadingSize="sm"
                            onClick={() =>
                                ParalisarAtendimento().then(() => {
                                    getAtendimento(Atendimento.ID_CASO).then(
                                        (e) => {
                                            AtendimentoPage.updateAtendimento();
                                            props.setDtSla(e.DT_SLA);
                                            ReloadHistorico();
                                        }
                                    );
                                })
                            }
                            disabled={
                                !selectedIDMotivoParalisacao ||
                                Atendimento.FL_CASO_PARALIZADO ||
                                paralisarAtendimentoLoading
                            }
                        >
                            Paralisar
                        </UnForm.SubmitButton>
                    </div>
                    <div className="mt-1">
                        <UnForm.SubmitButton
                            color="warning"
                            icon={faUndo}
                            loading={reiniciarAtendimentoLoading}
                            loadingSize="sm"
                            onClick={() => {
                                ReiniciarAtendimento().then(() => {
                                    getAtendimento(Atendimento.ID_CASO).then(
                                        (res) => {
                                            props.setDtSla(res.DT_SLA);
                                            AtendimentoPage.updateAtendimento();
                                            ReloadHistorico();
                                        }
                                    );
                                });
                            }}
                            disabled={
                                !Atendimento.FL_CASO_PARALIZADO ||
                                reiniciarAtendimentoLoading
                            }
                        >
                            Reiniciar
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>

            <AgendamentosDoAtendimento
                Atendimento={Atendimento}
                idCaso={Atendimento.ID_CASO}
            />
        </div>
    );
}
